"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "chiusdino": {
    "cec2e93b": [{
      "hkey": "45172d7b",
      "slug": "chiusdino",
      "name": "Chiusdino",
      "primary": true,
      "skipSearch": false
    }],
    "castelletto": [{
      "hkey": "45172d7b",
      "slug": "chiusdino",
      "name": "Chiusdino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c0290e39": [{
      "hkey": "45172d7b",
      "slug": "chiusdino",
      "name": "Chiusdino",
      "primary": true,
      "skipSearch": false
    }],
    "cetine": [{
      "hkey": "45172d7b",
      "slug": "chiusdino",
      "name": "Chiusdino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b4f9d566": [{
      "hkey": "ecd004e3",
      "slug": "palazzetto-ciglierese",
      "name": "Palazzetto-Ciglierese",
      "primary": true,
      "skipSearch": false
    }],
    "ciglierese": [{
      "hkey": "ecd004e3",
      "slug": "palazzetto-ciglierese",
      "name": "Palazzetto-Ciglierese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chiusdino"
    }],
    "d6a261ee": [{
      "hkey": "45172d7b",
      "slug": "chiusdino",
      "name": "Chiusdino",
      "primary": true,
      "skipSearch": false
    }],
    "luriano": [{
      "hkey": "45172d7b",
      "slug": "chiusdino",
      "name": "Chiusdino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "84a72968": [{
      "hkey": "769b693f",
      "slug": "montalcinello-moscufoli",
      "name": "Montalcinello-Moscufoli",
      "primary": true,
      "skipSearch": false
    }],
    "montalcinello": [{
      "hkey": "769b693f",
      "slug": "montalcinello-moscufoli",
      "name": "Montalcinello-Moscufoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1218471c": [{
      "hkey": "769b693f",
      "slug": "montalcinello-moscufoli",
      "name": "Montalcinello-Moscufoli",
      "primary": true,
      "skipSearch": false
    }],
    "muscufoli": [{
      "hkey": "769b693f",
      "slug": "montalcinello-moscufoli",
      "name": "Montalcinello-Moscufoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "chiusdino"
    }],
    "9e940c74": [{
      "hkey": "ecd004e3",
      "slug": "palazzetto-ciglierese",
      "name": "Palazzetto-Ciglierese",
      "primary": true,
      "skipSearch": false
    }],
    "palazzetto": [{
      "hkey": "ecd004e3",
      "slug": "palazzetto-ciglierese",
      "name": "Palazzetto-Ciglierese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5db90f1e": [{
      "hkey": "45172d7b",
      "slug": "chiusdino",
      "name": "Chiusdino",
      "primary": true,
      "skipSearch": false
    }],
    "pentolina": [{
      "hkey": "45172d7b",
      "slug": "chiusdino",
      "name": "Chiusdino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6db0a08d": [{
      "hkey": "45172d7b",
      "slug": "chiusdino",
      "name": "Chiusdino",
      "primary": true,
      "skipSearch": false
    }],
    "spannocchia": [{
      "hkey": "45172d7b",
      "slug": "chiusdino",
      "name": "Chiusdino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;